'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _profiles = require('./profiles.html');

var _profiles2 = _interopRequireDefault(_profiles);

var _profiles3 = require('./profiles.controller');

var _profiles4 = _interopRequireDefault(_profiles3);

require('./profiles.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var profilesComponent = {
  restrict: 'E',
  bindings: {},
  template: _profiles2.default,
  controller: _profiles4.default,
  controllerAs: 'vm'
};

exports.default = profilesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/profiles/profiles.component.js
 **/